{
  "removeButtonLabel": "Удалить",
  "removeDescription": "Нажмите DELETE, чтобы удалить тег."
}
